<div #qrShareCodePlaceholder class="qrShareCodePlaceholder bg-white"></div>
